export const MENU_ITEMS = [
  {
    title: 'Noticias',
    data: 'news',
    icon: 'book-open',
    home: true,
  },
  {
    title: 'Bitácoras',
    data: 'logbooks',
    icon: 'file-add',
  },
  {
    title: 'Programa anual',
    data: 'anualProgram',
    icon: 'calendar',
  },
  {
    title: 'Implementación SASISOPA',
    data: 'implementation',
    icon: 'checkmark-square-2',
  },
  {
    title: 'COVID-19',
    data: 'covid',
    icon: 'alert-circle',
  },
  {
    title: 'NOM-035',
    data: 'nom-035',
    icon: 'alert-circle',
  },
  {
    title: 'Calendario',
    data: 'calendar',
    icon: 'calendar',
  },
  {
    title: 'Requisitos Legales',
    data: 'legalRequirements',
    icon: 'archive',
  },
  {
    title: 'SASISOPA',
    data: 'sassisopa',
    icon: 'book',
  },
  {
    title: 'SGM',
    data: 'sgm',
    icon: 'briefcase',
  },
  {
    title: 'Personal',
    data: 'employees',
    icon: 'people',
  },
  {
    title: 'Usuarios',
    data: 'sysUsers',
    icon: 'person-add',
  },
  {
    title: 'Tutoriales/Webinars',
    data: 'tutorials',
    icon: 'video',
  },
  /*
  {
    title: 'Cursos',
    data: 'courses',
    icon: 'award',
  },
  */
];
